<div class="tidy-select-field">
  @if (label) {
    <tidy-text
      [fieldLabel]="label"
      class="field-label"
      [class.error]="!disableElement && !form.valid && submitted"
      (click)="openPanelFromLabel()" />
  }

  @if (multiple) {
    <div
      #selectContainer
      class="select-container multi-select-container"
      [class.invalid-field]="!disableElement && !form.valid && submitted"
      [class.disabled]="disableElement"
      (click)="openMultiSelectFromContainer($event)">
      @if (icon) {
        <tidy-image [src]="icon" class="input-icon no-right-margin" />
      }
      <mat-select
        #matMultiSelect
        [formControl]="form"
        [multiple]="true"
        [disabled]="disableElement"
        [placeholder]="helperText || '' | translate"
        [panelWidth]="panelWidth"
        (selectionChange)="onChange($event)"
        (openedChange)="onMultiSelectOpened($event)"
        panelClass="tidy-multi-select-panel"
        class="multi-select-input">
        <mat-select-trigger>
          {{ getMultiSelectDisplayValue() }}
        </mat-select-trigger>
        @if (showSearch) {
          <mat-option disabled class="multi-select-search-option">
            <div class="dropdown-search multi-select-search" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
              <tidy-image [src]="'assets/svg/search.svg'" class="search-icon" />
              <input
                #multiSelectSearchInput
                type="text"
                class="search-input"
                [placeholder]="searchPlaceholder || ('Search' | translate) | translate"
                [value]="searchValue"
                (input)="onMultiSelectSearchInput($event)"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
              />
              <button class="clear-button" [class.hidden]="!searchValue" (click)="clearMultiSelectSearch(); $event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </mat-option>
        }
        @for (item of filteredItems; track item) {
          <mat-option [value]="item.value" [disabled]="item.value === 'divider' || item.value === '__no_results__'">
            @if (item?.icon) {
              <tidy-image [src]="item?.icon" style="width:10px" />
            }
            {{ item.viewValue | translate }}
          </mat-option>
        }
      </mat-select>
      <div class="select-arrow" [class.disabled]="disableElement">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M5 4.5L8 2L11 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 11.5L8 14L11 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  } @else {
    <div
      #selectContainer
      class="select-container"
      [class.invalid-field]="!disableElement && !form.valid && submitted"
      [class.focused]="focused"
      matAutocompleteOrigin
      #origin="matAutocompleteOrigin"
      (mousedown)="onContainerMouseDown($event)">

      @if (icon) {
        <tidy-image [src]="icon" class="input-icon no-right-margin" />
      }

      @if (selectedItem?.dotColor) {
        <span class="select-status-dot" [style.--dot-color]="selectedItem.dotColor"></span>
      }

      <input
        #selectInput
        type="text"
        class="select-input"
        [placeholder]="helperText || '' | translate"
        [value]="getDisplayValue()"
        [readonly]="!showSearch"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        (input)="onSearchInput($event)"
        [matAutocomplete]="auto"
        [matAutocompleteConnectedTo]="origin"
        [disabled]="disableElement" />

      <div class="select-arrow" [class.disabled]="disableElement">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M5 4.5L8 2L11 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 11.5L8 14L11 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <mat-autocomplete
        #auto="matAutocomplete"
        [panelWidth]="panelWidth"
        panelClass="tidy-select-panel"
        (optionSelected)="onOptionSelected($event)"
        (opened)="onPanelOpened()"
        [autoActiveFirstOption]="false"
        [displayWith]="displayWithFn">
        @if (showSearch) {
          <div class="dropdown-search" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
            <tidy-image [src]="'assets/svg/search.svg'" class="search-icon" />
            <input
              #dropdownSearchInput
              type="text"
              class="search-input"
              [placeholder]="searchPlaceholder || ('Search' | translate) | translate"
              (input)="onDropdownSearchInput($event)"
              (focus)="onSearchFocus()"
              (blur)="onSearchBlur()"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            />
            <button class="clear-button" [class.hidden]="!searchValue" (click)="clearDropdownSearch(dropdownSearchInput); $event.stopPropagation()" (mousedown)="$event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
        @for (item of filteredItems; track item) {
          <mat-option [value]="item.value" [class.tidy-option-selected]="item.value === selectedValue" [disabled]="item.value === 'divider' || item.value === '__no_results__'" (mousedown)="onOptionMouseDown()" (click)="onOptionClicked(item)">
            @if (item?.dotColor) {
              <span class="select-status-dot" [style.--dot-color]="item.dotColor"></span>
            }
            @if (item?.icon) {
              <tidy-image [src]="item?.icon" style="width:10px" />
            }
            {{ item.viewValue | translate }}
            @if (item.isRecommended) {
              <span style="color: #4CAF50; font-size: 12px; margin-left: 8px;">(Recommended)</span>
            }
          </mat-option>
        }
      </mat-autocomplete>
    </div>
  }

  @if (!disableElement && !form.valid && submitted) {
    <tidy-error-message [text]="errorMessage" />
  }
</div>